import styles from "./PublicationPage.module.scss";
import ContentArea, {
  ContentAreaProps,
} from "components/utils/ContentArea/ContentArea";
import PublicationPageHeroBlock from "components/blocks/PublicationPageHeroBlock/PublicationPageHeroBlock";
import { PublicationPageHeroBlockProps } from "components/blocks/PublicationPageHeroBlock/PublicationPageHeroBlock";
import { TopPageBlocksProps } from "components/shared/TopPageBlocks/TopPageBlocks";
import CardListBlock, {
  CardListBlockProps,
} from "components/blocks/CardListBlock/CardListBlock";
import { AlertBlock } from "SiteComponents";
import ContactBlock, {
  ContactBlockProps,
} from "components/blocks/ContactBlock/ContactBlock";

export interface PublicationPageProps extends TopPageBlocksProps {
  contentArea: ContentAreaProps;
  contactBlock?: ContactBlockProps;
  hero: PublicationPageHeroBlockProps;
  reportChapters?: CardListBlockProps;
  relatedReports?: CardListBlockProps;
}

const PublicationPage: React.FC<PublicationPageProps> = ({
  contentArea,
  contactBlock,
  hero,
  alert,
  mainIntro,
  reportChapters,
  relatedReports,
}) => {
  return (
    <main className={styles.publicationPage} id="main-content">
      {hero && <PublicationPageHeroBlock {...hero} />}
      <div className={styles.grid}>
        {(alert || mainIntro) && (
          <div className={styles.main}>
            {alert && <AlertBlock {...alert} />}
            {mainIntro && <p className={styles.mainIntro}>{mainIntro}</p>}
          </div>
        )}

        {contactBlock && (
          <div className={styles.aside}>
            <ContactBlock {...contactBlock} />
          </div>
        )}

        <div className={styles.main}>
          {(contentArea || relatedReports) && contentArea && (
            <ContentArea
              className={styles.contentArea}
              {...contentArea}
              noGrid
            />
          )}
        </div>
        {reportChapters?.listItems && (
            reportChapters.theme === "flatImageWithTitle" ? (
              <div className={styles.fullWidth}>
                <CardListBlock {...reportChapters} />
              </div>
            ) : (
              <div className={styles.main}>
                <CardListBlock {...reportChapters} />
              </div>
            )
          )}
        <div className={styles.fullWidth}>
          {relatedReports && <CardListBlock {...relatedReports} />}
        </div>
      </div>
    </main>
  );
};

export default PublicationPage;
